<template>
  <el-card>
    <el-menu
      class="el-menu-vertical-demo"
      @select="handleOpen"
    >
      <el-menu-item
        v-for="(enquiry, index) in enquiries"
        :key="index"
        :index="index"
      >
        <i :class="getIcon(enquiry.type)" />
        <span>{{ enquiry.subject }}</span>
      </el-menu-item>
    </el-menu>
  </el-card>
</template>
<script>
export default {
  props: {
    enquiries: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleOpen (key) {
      this.$emit('change', key)
    },
    getIcon (type) {
      switch (type) {
        case 'Additional Delivery Instructions':
          return 'el-icon-chat-dot-square'
        case 'ATL Request':
          return 'el-icon-house'
        case 'Cancel Consignment':
          return 'el-icon-delete'
        case 'Check Address':
          return 'el-icon-map-location'
        case 'Contact Details Required':
          return 'el-icon-user'
        case 'Damaged Freight':
          return 'el-icon-picture-outline'
        case 'Depot Collection':
          return 'el-icon-office-building'
        case 'ETA Request':
          return 'el-icon-watch'
        case 'Lost in Transit':
          return 'el-icon-discover'
        case 'Missed Pickup':
          return 'el-icon-shopping-cart-1'
        case 'Missing Paperwork':
          return 'el-icon-document-delete'
        case 'Monitor':
          return 'el-icon-monitor'
        case 'Partial Lost in Transit':
          return 'el-icon-discover'
        case 'POD Request':
          return 'el-icon-camera'
        case 'Pre-alert':
          return 'el-icon-bell'
        case 'Redelivery Request':
          return 'el-icon-guide'
        case 'Reporting':
          return 'el-icon-data-analysis'
        case 'Return to Sender':
          return 'el-icon-refresh-left'
        case 'Short Delivery':
          return 'el-icon-connection'
        case 'WOP Letter':
          return 'el-icon-tickets'
        default:
          return 'el-icon-menu'
      }
    }
  }
}
</script>
